import deepEqual from 'fast-deep-equal';
import { updateDashboardData } from '@deephaven/dashboard';
import { getLinksForDashboard } from "./selectors.js";
/**
 * Set the connection for the dashboard specified
 * @param id The ID of the dashboard to set the connection for
 * @param connection The connection object to set for the dashboard
 */
export var setDashboardConnection = (id, connection) => dispatch => dispatch(updateDashboardData(id, {
  connection
}));

/**
 * Set the session wrapper for the dashboard specified
 * @param id The ID of the dashboard to set the session for
 * @param sessionWrapper The session wrapper object to set for the dashboard
 */
export var setDashboardSessionWrapper = (id, sessionWrapper) => dispatch => dispatch(updateDashboardData(id, {
  sessionWrapper
}));

/**
 * Set the links for a given dashboard
 * @param id The ID of the dashboard to set the links for
 * @param links The links to set
 */
export var setDashboardLinks = (id, links) => dispatch => dispatch(updateDashboardData(id, {
  links
}));

/**
 * Add links to the existing links in a dashboard. Filters out any duplicate links.
 * @param id The ID of the dashboard to add links to
 * @param newLinks The new links to add
 */
export var addDashboardLinks = (id, newLinks) => (dispatch, getState) => {
  var links = getLinksForDashboard(getState(), id);
  var filtered = newLinks.filter(newLink => links.findIndex(link => deepEqual(link.start, newLink.start) && deepEqual(link.end, newLink.end)) < 0);
  return dispatch(setDashboardLinks(id, links.concat(filtered)));
};

/**
 * Delete links from a dashboard
 * @param id The ID of the dashboard to delete links from
 * @param linkIds The link IDs to delete
 */
export var deleteDashboardLinks = (id, linkIds) => (dispatch, getState) => {
  var links = getLinksForDashboard(getState(), id);
  var newLinks = links.filter(link => !linkIds.includes(link.id));
  return dispatch(setDashboardLinks(id, newLinks));
};

/**
 * Set the isolated linker panel ID for a dashboard
 * @param id The ID of the dashboard to set the isolated linker panel ID in
 * @param isolatedLinkerPanelId The isolated panel ID, or undefined to unset
 */
export var setDashboardIsolatedLinkerPanelId = (id, isolatedLinkerPanelId) => dispatch => dispatch(updateDashboardData(id, {
  isolatedLinkerPanelId
}));

/**
 * Set the column selection validator for a dashboard
 * @param id The ID of the dashboard to set the column selection validator on
 * @param columnSelectionValidator The column selection validator to set
 */
export var setDashboardColumnSelectionValidator = (id, columnSelectionValidator) => dispatch => dispatch(updateDashboardData(id, {
  columnSelectionValidator
}));

/**
 * Set the console settings for a dashboard
 * @param id The ID of the dashboard to set the console settings on
 * @param consoleSettings The console settings to set for the dashboard
 */
export var setDashboardConsoleSettings = (id, consoleSettings) => dispatch => dispatch(updateDashboardData(id, {
  consoleSettings
}));

/**
 * Set the filter sets for a specific dashboard
 * @param id The ID of the dashboard to set the filter sets for
 * @param filterSets The filter sets to set
 */
export var setDashboardFilterSets = (id, filterSets) => dispatch => dispatch(updateDashboardData(id, {
  filterSets
}));
//# sourceMappingURL=actions.js.map